import { IAuthState } from "Auth/state";
import { IToastState } from "shared/components/Toast";
import { IMessageState } from "shared/components/MessageModal";
import { IUnitState } from "shared/components/UnitConverter";
import { IPermissionForKey, IPermissionKey, IDataState } from "shared/types";

export enum IRouteType {
  private,
  auth,
  public,
  permission,
  admin,
}
export interface IRoute {
  Component: React.FC<any>;
  path: string;
  title?: string;
  exact?: boolean;
  type?: IRouteType;
  permissions?: IPermissionForKey[];
  permissionType?: IPermissionKey;
  [key: string]: any;
}

export interface IStoreState {
  auth: IAuthState;
  data: IDataState;
  bandData: IDataState;
  toasts: IToastState;
  message: IMessageState;
  units: IUnitState;
}
